export default "__VITE_ASSET__5dd8ca61__"